import { ISignUpResult } from 'amazon-cognito-identity-js';

export enum AuthEpicsActionTypes {
  INPUT_EMAIL = 'INPUT_EMAIL',
  SIGN_UP = 'SIGN_UP',
  SIGN_UP_SUCCEEDED = 'SIGN_UP_SUCCEEDED',
  SIGN_UP_FAILED = 'SIGN_UP_FAILED',
  VERIFICATION_CODE = 'VERIFICATION_CODE',
  VERIFICATION_CODE_SUCCEDED = 'VERIFICATION_CODE_SUCCEDED',
  VERIFICATION_CODE_FAILED = 'VERIFICATION_CODE_FAILED',
  SIGN_IN = 'SIGN_IN',
  SIGN_IN_SUCCEEDED = 'SIGN_IN_SUCCEEDED',
  SIGN_IN_FAILED = 'SIGN_IN_FAILED',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCEEDED = 'FORGOT_PASSWORD_SUCCEEDED',
  FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED',
  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
  CONFIRM_PASSWORD_SUCCEEDED = 'CONFIRM_PASSWORD_SUCCEEDED',
  CONFIRM_PASSWORD_FAILED = 'CONFIRM_PASSWORD_FAILED',
  INIT_CLIENT_REQUEST = 'INIT_CLIENT_REQUEST',
  INIT_CLIENT_SUCCEEDED = 'INIT_CLIENT_SUCCEEDED',
  INIT_CLIENT_FAILED = 'INIT_CLIENT_FAILED',
  SIGN_OUT = 'SIGN_OUT',
  SIGN_OUT_SUCCEEDED = 'SIGN_OUT_SUCCEEDED',
  SIGN_OUT_FAILED = 'SIGN_OUT_FAILED',
}

export interface InputEmail {
  type: AuthEpicsActionTypes.INPUT_EMAIL;
  email: string;
}

export interface SignUpUser {
  type: AuthEpicsActionTypes.SIGN_UP;
  email: string;
  password: string;
}

export interface SignUpSucceeded {
  type: AuthEpicsActionTypes.SIGN_UP_SUCCEEDED;
  user: ISignUpResult;
}

export interface SignUpFailed {
  type: AuthEpicsActionTypes.SIGN_UP_FAILED;
  error: Error;
}

export interface VerificationCode {
  type: AuthEpicsActionTypes.VERIFICATION_CODE;
  email: string;
  code: string;
}

export interface VerificationCodeSucceded {
  type: AuthEpicsActionTypes.VERIFICATION_CODE_SUCCEDED;
  code: string;
}

export interface VerificationCodeFailed {
  type: AuthEpicsActionTypes.VERIFICATION_CODE_FAILED;
  error: Error;
}

export interface SignInUser {
  type: AuthEpicsActionTypes.SIGN_IN;
  email: string;
  password: string;
}

export interface SignInSucceeded {
  type: AuthEpicsActionTypes.SIGN_IN_SUCCEEDED;
  session: any;
}

export interface SignInFailed {
  type: AuthEpicsActionTypes.SIGN_IN_FAILED;
  error: Error;
}

export interface ForgotPassword {
  type: AuthEpicsActionTypes.FORGOT_PASSWORD;
  email: string;
}

export interface ForgotPasswordSucceeded {
  type: AuthEpicsActionTypes.FORGOT_PASSWORD_SUCCEEDED;
}

export interface ForgotPasswordFailed {
  type: AuthEpicsActionTypes.FORGOT_PASSWORD_FAILED;
  error: Error;
}

export interface ConfirmPassword {
  type: AuthEpicsActionTypes.CONFIRM_PASSWORD;
  email: string;
  verificationCode: string;
  newPassword: string;
}

export interface ConfirmPasswordSucceeded {
  type: AuthEpicsActionTypes.CONFIRM_PASSWORD_SUCCEEDED;
}

export interface ConfirmPasswordFailed {
  type: AuthEpicsActionTypes.CONFIRM_PASSWORD_FAILED;
  error: Error;
}

export interface InitClientRequest {
  type: AuthEpicsActionTypes.INIT_CLIENT_REQUEST;
}

export interface InitClientSucceeded {
  type: AuthEpicsActionTypes.INIT_CLIENT_SUCCEEDED;
  response: object;
}

export interface InitClientFailed {
  type: AuthEpicsActionTypes.INIT_CLIENT_FAILED;
  error: Error;
}

export interface SignOut {
  type: AuthEpicsActionTypes.SIGN_OUT;
}

export interface SignOutSucceeded {
  type: AuthEpicsActionTypes.SIGN_OUT_SUCCEEDED;
}

export interface SignOutFailed {
  type: AuthEpicsActionTypes.SIGN_OUT_FAILED;
  error: Error;
}

export type AuthEpicsActions =
  | InputEmail
  | SignUpUser
  | SignUpSucceeded
  | SignUpFailed
  | SignInUser
  | SignInSucceeded
  | SignInFailed
  | VerificationCode
  | VerificationCodeSucceded
  | VerificationCodeFailed
  | ForgotPassword
  | ForgotPasswordSucceeded
  | ForgotPasswordFailed
  | ConfirmPassword
  | ConfirmPasswordSucceeded
  | ConfirmPasswordFailed
  | InitClientRequest
  | InitClientSucceeded
  | InitClientFailed
  | SignOut
  | SignOutSucceeded
  | SignOutFailed;

export function inputEmail(email: string): InputEmail {
  return {
    type: AuthEpicsActionTypes.INPUT_EMAIL,
    email,
  };
}

export function signUpUser(email: string, password: string): SignUpUser {
  return {
    type: AuthEpicsActionTypes.SIGN_UP,
    email,
    password,
  };
}

export function signUpSucceeded(user: ISignUpResult): SignUpSucceeded {
  return {
    type: AuthEpicsActionTypes.SIGN_UP_SUCCEEDED,
    user,
  };
}

export function signUpFailed(error: Error): SignUpFailed {
  return {
    type: AuthEpicsActionTypes.SIGN_UP_FAILED,
    error,
  };
}

export function verificationCode(email: string, code: string): VerificationCode {
  return {
    type: AuthEpicsActionTypes.VERIFICATION_CODE,
    email,
    code,
  };
}

export function verificationCodeSucceded(code: string): VerificationCodeSucceded {
  return {
    type: AuthEpicsActionTypes.VERIFICATION_CODE_SUCCEDED,
    code,
  };
}

export function verificationCodeFailed(error: Error): VerificationCodeFailed {
  return {
    type: AuthEpicsActionTypes.VERIFICATION_CODE_FAILED,
    error,
  };
}

export function signInUser(email: string, password: string): SignInUser {
  return {
    type: AuthEpicsActionTypes.SIGN_IN,
    email,
    password,
  };
}

export function signInSucceeded(session: any): SignInSucceeded {
  return {
    type: AuthEpicsActionTypes.SIGN_IN_SUCCEEDED,
    session,
  };
}

export function signInFailed(error: Error): SignInFailed {
  return {
    type: AuthEpicsActionTypes.SIGN_IN_FAILED,
    error,
  };
}

export function forgotPassword(email: string): ForgotPassword {
  return {
    type: AuthEpicsActionTypes.FORGOT_PASSWORD,
    email,
  };
}

export function forgotPasswordSucceeded(): ForgotPasswordSucceeded {
  return {
    type: AuthEpicsActionTypes.FORGOT_PASSWORD_SUCCEEDED,
  };
}

export function forgotPasswordFailed(error: Error): ForgotPasswordFailed {
  return {
    type: AuthEpicsActionTypes.FORGOT_PASSWORD_FAILED,
    error,
  };
}

export function confirmPassword(email: string, verificationCode: string, newPassword: string): ConfirmPassword {
  return {
    type: AuthEpicsActionTypes.CONFIRM_PASSWORD,
    email,
    verificationCode,
    newPassword,
  };
}

export function confirmPasswordSucceeded(): ConfirmPasswordSucceeded {
  return {
    type: AuthEpicsActionTypes.CONFIRM_PASSWORD_SUCCEEDED,
  };
}

export function confirmPasswordFailed(error: Error): ConfirmPasswordFailed {
  return {
    type: AuthEpicsActionTypes.CONFIRM_PASSWORD_FAILED,
    error,
  };
}

export function initClientRequest() {
  return {
    type: AuthEpicsActionTypes.INIT_CLIENT_REQUEST,
  };
}

export function InitClientSucceeded(response) {
  return {
    type: AuthEpicsActionTypes.INIT_CLIENT_SUCCEEDED,
    response,
  };
}

export function InitClientFailed(error) {
  return {
    type: AuthEpicsActionTypes.INIT_CLIENT_FAILED,
    error,
  };
}

export function signOut() {
  return {
    type: AuthEpicsActionTypes.SIGN_OUT,
  };
}

export function signOutSucceeded() {
  return {
    type: AuthEpicsActionTypes.SIGN_OUT_SUCCEEDED,
  };
}

export function signOutFailed(error) {
  return {
    type: AuthEpicsActionTypes.SIGN_OUT_FAILED,
    error,
  };
}
